import React from "react";
import styled from "styled-components";

const TAB_HOVER_COLOR = "#F7941D";

const breakpoints = {
  tablet: 768,
  phone:  480,
};

const TabsContainer = styled.ul`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  list-style-type: none;
  border-bottom: 2px solid #ccc;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 0 4px 0;

  li {
    margin-right: 10px;
    margin-bottom: 14px;
    flex: 0 0 auto;
  }

  a {
    display: inline-block;
    text-decoration: none;
    padding: 10px 10px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: ${(props) => props.colors.cardBackground};
    color: ${(props) => props.colors.buttonBackground};
    transition: all 0.3s;
    font-weight: 600;
    white-space: nowrap;
    line-height: 1.2;

    &.selected {
      background-color: ${(props) => props.colors.buttonBackground};
      color: white;
      border-color: ${(props) => props.colors.buttonBackground};
    }

    &:not(.selected) {
      background-color: ${(props) => props.colors.titleText};
      color: ${(props) => props.colors.buttonBackground};
    }

    &:hover {
      background-color: ${TAB_HOVER_COLOR};
      border-color: ${TAB_HOVER_COLOR};
      color: white;
    }
  }
    @media (max-width: ${breakpoints.phone}px) {
    padding: 1em 2em;
    margin-bottom: 1em;
    li {
      flex: 0 0 auto;
      margin-right: 0.5em;
    }
  }
`;

const ReportTabs = ({ colors, selectedTab, handleTabClick }) => {
  const tabs = [
    "Compliance Doc Reports",
    "Certification Reports",
    "E-Rate Cert Reports",
    "Module Download Report",
    "Other Internet Safety"
  ];

  return (
    <TabsContainer colors={colors}>
      {tabs.map((tab) => (
        <li key={tab}>
          <a
            href="#"
            className={selectedTab === tab ? "selected" : ""}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </a>
        </li>
      ))}
    </TabsContainer>
  );
};

export default ReportTabs;
